import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import Switch from '@material-ui/core/Switch';

const ColoredSwitch = withStyles({
    thumb: {
        backgroundColor: '#fff',
    },
    checked: {
        "& $thumb": {
          backgroundColor: "var(--jmi-green)"
        },
        "& + $track": {
          opacity: "1 !important"
        }
    },
    switchBase: {
        color: "rgba(0,0,0,0.38)",
        '&$checked + $track': {
            backgroundColor: 'var(--jmi-green)',
        },
      },
    })(props => <Switch color="default" {...props} />);

export default ColoredSwitch;